module.exports = __webpack_public_path__ + "img/person-unknown.4a4fe284.svg";